import AdminSimulatorDataStore from '../../datastores/AdminSimulatorDataStore';

const dataResponse = [
  {
    studentCode: 'U20309615',
    peopleCode: '00001358526',
    dni: '11111123',
    firstName: 'Ivan Manuel',
    lastName: 'Enciso'
  },
  {
    studentCode: 'U20309616',
    peopleCode: '00001358527',
    dni: '11111124',
    firstName: 'Pedro Zuñiga'
  },
  {
    studentCode: 'U20309617',
    peopleCode: '00001358528',
    dni: '11111125',
    firstName: 'Gerardo Artigas'
  }
];
export default class AdminSimulatorDataStoreMock
  implements AdminSimulatorDataStore
{
  async getStudentInformationById(studentId: string) {
    return dataResponse.find(
      (studentMock) => studentMock.studentCode === studentId
    );
  }
}
